import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import { FaBell, FaHome } from "react-icons/fa";
import FabellOutlinedRounded from "../icons/FabellOutlinedRounded.svg";
import Fahome from "../icons/Fahome.svg";
import UserSettings from "../icons/UserSettings.svg";
import IconButton from "@mui/material/IconButton";
import { Tooltip, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import defaultImage from "../icons/profile-default.png";
import { useAuthContext } from "../../../hooks/Auth";
import { useJobContext } from "../../../hooks/Jobs";
import ProfileModal from "./ProfileModal";
import "./ProfileMenu.css";
import ClearCacheButton from "../../../components/utils/ClearCacheButton";
import { freshDesk } from "../../../utils/freshDesk";


export default function ProfileMenu() {
  const { user } = useAuthContext();
  const { showNotification } = useJobContext();
  const [image, setImage] = useState(defaultImage);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [verNotificacion, setVerNotificacion] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if (user?.picture) {
      setImage(user.picture);
    }
  }, [user]);

  const handleVerNotificacion = () => {
    setVerNotificacion(false);
  };

  useEffect(() => {
    if (showNotification === true) {
      setVerNotificacion(true);
    }
  }, [showNotification]);


  {/**Funciones encargadas del chat FreshDesk */}

   useEffect(() => {
      if (typeof window.FreshworksWidget === "function") {
        window.FreshworksWidget("on", "widget:loaded", () => {
          window.FreshworksWidget?.("hide", "launcher");
        });
      }
    }, []);
  
    /* Función para inicializar el widget 'freshDesk' para soporte */
    useEffect(() => {
      freshDesk();
    }, []);
  
    const handleOpenChat = () => {
      if (typeof window.FreshworksWidget === "function") {
        window.FreshworksWidget("open");
      }
    };

  return (
    <>
      {/* Menú en navbar */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          textAlign: "center",
          gap: "4px",
        }}
      >

        <Box
            sx={{
              display: "flex", 
              alignItems: "center",
              fontSize: { xs: "1.15rem", md: "1.25rem" },
              color: "#0000008A",
            }}
            onClick={handleVerNotificacion}
          >
            <ClearCacheButton />
          </Box>


        <Link to="/asistente/myplaninginprocess">
          <Box
            sx={{
              display: "flex", 
              alignItems: "center",
              fontSize: { xs: "1.15rem", md: "1.25rem" },
              color: "#0000008A",
            }}
            onClick={handleVerNotificacion}
          >
            <Box
              component="img"
              src={FabellOutlinedRounded}
              alt="Notificación"
              sx={{ width: 24, height: 24 }}
            />
            {verNotificacion && (
              <Tooltip title="Tienes 1 proceso finalizado">
                <div className="notification-bubble" />
              </Tooltip>
            )}
          </Box>
        </Link>
        <IconButton onClick={handleOpenChat} size="small">
          <Box
            component="img"
            src={Fahome}
            alt="User Settings"
            sx={{ width: 28, height: 28 }}
          />
        </IconButton>
        <IconButton onClick={handleClick} size="small">
          <Box
            component="img"
            src={UserSettings}
            alt="User Settings"
            sx={{ width: 28, height: 28 }}
          />
        </IconButton>
      </Box>

      {/* Menu modal */}
      <ProfileModal anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
      
    </>
  );
}
